import { Google, TikTok, Twitter } from 'almanac-ui/icons'
import { YouTubeBrand } from 'blaze-ui/icons/20'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { LinkedInBrand } from 'blaze-ui/icons/32'
import { FacebookBrand } from 'blaze-ui/icons/35'

export interface CompanySizeEnum {
  title: string
  value: number
}

export interface OnboardingQuestionOption<T> {
  title: string
  description?: string
  value: T
  icon?: string | JSX.Element
}

export const businessDescriptionOptions: OnboardingQuestionOption<string>[] = [
  { icon: '🎨', title: 'Agency', description: 'Client services', value: 'agency' },
  { icon: '👩🏽‍💻', title: 'Consulting', description: 'Strategy & expertise', value: 'consulting' },
  { icon: '👨🏻‍💼', title: 'Executive Coach', description: 'Personal growth', value: 'coaching' },
  { icon: '🏋️', title: 'Fitness', description: 'Health & Wellness', value: 'fitness' },
  { icon: '👩🏽‍🎨', title: 'Creator', description: 'Content & media', value: 'creator' },
  { icon: '🛍️', title: 'Ecommerce', description: 'Online retail', value: 'ecommerce' },
  { icon: '📚', title: 'Education', description: 'Learning & training', value: 'education' },
  { icon: '💰', title: 'Finance', description: 'Financial services', value: 'finance' },
  { icon: '💻', title: 'Freelancer', description: 'Solo professional', value: 'freelancer' },
  { icon: '💈', title: 'Local Service', description: 'Community-based', value: 'local_service' },
  { icon: '⛓️', title: 'Manufacturing', description: 'Physical products', value: 'manufacturing' },
  { icon: '⛑️', title: 'Nonprofit', description: 'Social impact', value: 'nonprofit' },
  { icon: '🏡', title: 'Real Estate', description: 'Property services', value: 'real_estate' },
  { icon: '💾', title: 'Software', description: 'Digital products', value: 'software' },
  { icon: '🌼', title: 'Startup', description: 'Early-stage venture', value: 'startup' },
  { icon: '✈️', title: 'Travel', description: 'Travel services', value: 'travel' },
  { icon: '🤷', title: 'Other', description: 'Something else', value: 'other' },
]

export const signUpOptions: OnboardingQuestionOption<string>[] = [
  { title: 'Get started with content online', value: 'get_started_with_content' },
  { title: 'Build my brand', value: 'build_my_brand' },
  { title: 'Raise awareness', value: 'raise_awareness' },
  { title: 'Produce great ads', value: 'produce_ads' },
  { title: 'Communicate with customers', value: 'communicate_with_customers' },
  { title: 'Collaborate with my team / clients', value: 'collaborate_with_clients' },
  { title: 'Create months of content', value: 'create_content' },
  { title: 'Get more content ideas', value: 'get_content_ideas' },
  { title: 'Organize, plan, and post content', value: 'organize_content' },
]

export const sizeOptions: OnboardingQuestionOption<string>[] = [
  { value: 'just_me', title: 'Just me' },
  { value: '2-5', title: '2-5 people' },
  { value: '5-10', title: '5-10 people' },
  { value: '10-20', title: '10-20 people' },
  { value: '20-50', title: '20-50 people' },
  { value: '50-100', title: '50-100 people' },
  { value: '100+', title: '100+ people' },
]

export const blazeDiscoveryOptions: OnboardingQuestionOption<string>[] = [
  { icon: <InstagramBrand size={20} />, title: 'Instagram', value: 'instagram' },
  { icon: <FacebookBrand size={20} />, title: 'Facebook', value: 'facebook' },
  { icon: <LinkedInBrand size={20} />, title: 'LinkedIn', value: 'linkedin' },
  { icon: <Google size={20} />, title: 'Google', value: 'google' },
  { icon: <YouTubeBrand size={20} />, title: 'YouTube', value: 'youtube' },
  { icon: <TikTok size={20} />, title: 'TikTok', value: 'tiktok' },
  { icon: <Twitter size={20} />, title: 'X/Twitter', value: 'x' },
  { icon: '👩‍🦰', title: 'From a Friend', value: 'friend' },
  { icon: '🌟', title: 'Review Site', value: 'review' },
  { icon: '✍️', title: 'Blog', value: 'blog' },
  { icon: '🎉', title: 'Event / Webinar', value: 'event' },
  { icon: '🎙️', title: 'Podcast', value: 'podcast' },
  { icon: '🤷🏽‍♀️', title: 'Other', value: 'other' },
]

export const invalidDomains = ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com']
